/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=SvgIcon&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=SvgIcon&lang=js"

import "./index.vue?vue&type=style&index=0&id=5d5b8a68&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5b8a68"]])

export default __exports__